import React from "react";
import CrmButton from "./CrmButton";
import CrmModal from "./CrmModal";

const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false
}) => {
  return (
    <CrmModal
      open={open}
      title={title}
      size="sm"
      closeOnBackdrop={!loading}
      closeOnEscape={!loading}
      onClose={loading ? undefined : onCancel}
      footer={(
        <>
          <CrmButton
            variant="secondary"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </CrmButton>
          <CrmButton
            variant="danger"
            onClick={onConfirm}
            loading={loading}
          >
            {confirmText}
          </CrmButton>
        </>
      )}
    >
      <p className="crm-secondary-text">{message}</p>
    </CrmModal>
  );
};

export default ConfirmDialog;
